/* ============================================================
   assets/int-size-select.js                 INTENTION — 2026-09-03
   THE SIZE DROPDOWN THAT DRIVES THE REAL RADIOS. Apparel, every width.

   ⚑ WHERE IT CAME FROM. This was block 5 of assets/int-pdp-mobile.js, lifted
   out verbatim on 2026-09-03. That file returns above 820px, so the mirror
   only worked on the phone. Nils asked for the same dropdown on desktop,
   beside the price, so the wiring had to leave a file that is mobile-only by
   construction. Same move as assets/int-zoom.js the same day.

   ⚑ THE MARKUP IS STILL snippets/int-pdp-mobile.liquid. Only the wiring moved.
   "Move the call, not the code": one implementation, two breakpoints.

   ⚑ ON DESKTOP IT ALSO MOVES. The control is inserted as the first child of
   .product__block__price so the closed box sits on the same line as the
   price, which is what Nils asked for. That is a DOM move, and DOM moves are
   normally avoided on this page for first-paint reasons — it is safe here
   because the control is held at visibility:hidden until it is wired, so
   nothing is ever seen in the wrong place. The radios themselves NEVER move:
   moving .selector-wrapper nodes is what broke Shopify's sellout preview on
   2026-09-03 (it matches variants by FormData position), and the fix was to
   mirror rather than move. Do not "simplify" this by relocating the radios.

   ⚑ ITS DESKTOP STYLING IS assets/int-pdp-desktop.css. The mobile styling
   stays in assets/int-pdp-mobile.css.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intSizeSelect) return;
  window.__intSizeSelect = true;

  function q(sel, root) { return (root || document).querySelector(sel); }

  var DESKTOP = '(min-width: 821px)';

  function mount() {
  var sel = document.getElementById('int-mob-size-select');
  if (sel) {
    var wrap = q('[data-select-label="Size"]');

    function radios() {
      return wrap ? wrap.querySelectorAll('input[type="radio"]') : [];
    }
    /* ⚑ Mirror availability. The theme does NOT disable an unavailable size
       radio: it marks the wrapping .radio__button with `int-region-oos`
       (see int-region-stock.liquid) and draws a diagonal bar through the
       chip, and clicking it opens the back in stock / notify flow. A
       dropdown cannot draw that bar, and `option[disabled]` would block
       the notify flow, so the option keeps its click and says so in words.
       Availability changes with the COLOUR, so this re-runs on
       variant:change. */
    /* Nils, 2026-09-01: the wording is "N/A. Notify me." — it says what is
       true AND what tapping it does, since picking one opens the notify
       flow. The closed box carries the short form so the 44px control does
       not have to hold a sentence. */
    var OOS_SUFFIX = ' \u00b7 N/A. Notify me.';
    var OOS_SUFFIX_FACE = ' \u00b7 N/A';
    function isOos(radio) {
      var host = radio.closest && radio.closest('.radio__button, radio-swatch');
      return !!(host && host.classList.contains('int-region-oos')) || !!radio.disabled;
    }
    function syncDisabled() {
      var rs = radios();
      for (var i = 0; i < rs.length; i++) {
        var v = String(rs[i].value);
        var opt = sel.querySelector('option[value="' + v.replace(/"/g, '\\"') + '"]');
        if (!opt) continue;
        opt.textContent = isOos(rs[i]) ? (v + OOS_SUFFIX) : v;
      }
    }
    var faceVal = q('.int-mob-size__val');
    function paintFace() {
      if (!faceVal) return;
      var v = sel.value, oos = false, rs = radios();
      for (var i = 0; i < rs.length; i++) {
        if (rs[i].value === v) { oos = isOos(rs[i]); break; }
      }
      faceVal.textContent = oos ? (v + OOS_SUFFIX_FACE) : v;
    }
    function syncFromRadios() {
      var rs = radios();
      for (var i = 0; i < rs.length; i++) {
        if (rs[i].checked && sel.value !== rs[i].value) { sel.value = rs[i].value; break; }
      }
      syncDisabled();
      paintFace();
    }

    sel.addEventListener('change', function () {
      paintFace();
      var rs = radios(), v = sel.value;
      for (var i = 0; i < rs.length; i++) {
        if (rs[i].value === v) {
          if (!rs[i].checked) rs[i].click();
          return;
        }
      }
      /* The theme renders an option as a popout instead of buttons when a
         value is 16 characters or longer. No apparel size is, but a future
         one could be, and a dead dropdown would be silent. */
      var po = wrap && wrap.querySelector('.select-popout__option[data-value="' + v.replace(/"/g, '\\"') + '"]');
      if (po) po.click();
    });

    /* A Find My Size result clicks a radio, which fires variant:change.
       That is how the recommended size reaches this dropdown and the
       measurement line at the same time. */
    document.addEventListener('variant:change', syncFromRadios, false);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio' && wrap && wrap.contains(e.target)) syncFromRadios();
    }, false);
    /* 2026-10-04 (Nils): the remembered size was already painted into the closed box by
       the inline script in snippets/product-price.liquid (window.__intPreSize). Here the
       matching REAL radio is clicked once, before the first mirror pass, so the variant,
       price and URL follow the box instead of the box being reset to the first size and
       flipped back by the fit quiz a second later. A sold out size is left alone and the
       mirror below resets the box, exactly as before. */
    var pre = window.__intPreSize;
    if (pre && pre.v) {
      var prs = radios();
      for (var pi = 0; pi < prs.length; pi++) {
        if (prs[pi].value === pre.v) {
          if (!prs[pi].checked && !isOos(prs[pi])) prs[pi].click();
          break;
        }
      }
    }
    syncFromRadios();
    [400, 1200, 2500].forEach(function (ms) { setTimeout(syncFromRadios, ms); });
  }
    /* ⚑ DESKTOP ONLY: put the closed box on the price line. Below 821px the
       control keeps the place the order layer gives it, under the swatches. */
    try {
      if (window.matchMedia && window.matchMedia(DESKTOP).matches) {
        var box = q('.int-mob-size');
        var price = q('.product__block__price');
        if (box && price && !price.contains(box)) {
          /* ⚑ THE PRICE AND ITS TAX NOTE HAVE TO BE WRAPPED FIRST.
             .product__block__price becomes a flex ROW so the size control can
             sit beside the price. Its own children — the price and the
             "Taxes included." note — are siblings, so without a wrapper the
             row laid all three out side by side and the note ended up to the
             RIGHT of the price instead of under it. Measured: size at x=813,
             price at 957, note at 1138.
             Wrapping them keeps the row at two items and lets the pair stack
             and right align as one block. */
          var stack = document.createElement('div');
          stack.className = 'int-price-stack';
          while (price.firstChild) stack.appendChild(price.firstChild);
          price.appendChild(stack);
          price.insertBefore(box, price.firstChild);
        }
        /* 2026-09-19: OUTSIDE THE GUARD ON PURPOSE. The control and the stack
           are server rendered into .product__block__price now, so
           `!price.contains(box)` is FALSE and the block above never runs. This
           class is what releases
           `body:not(.int-size-on-price) .product__block__price .int-mob-size
            { visibility: hidden !important }` in assets/int-pdp-desktop.css.
           Left inside the guard it would never land and the control would stay
           hidden for good on desktop. Same shape as assets/int-fp-select.js
           line 145, which adds int-fp-buyrow-desktop outside its own guard. */
        document.body.classList.add('int-size-on-price');

        /* ⚑ THE FIT TILE GOES WHERE IT GOES ON THE PHONE. Nils: "Move size
           fit box button thing to the same place as on mobile."
           assets/int-pdp-mobile.js builds a `.int-mob-fit` holder under the
           delivery panel and moves #fake-fit-quiz into it; that file returns
           above 820px, so desktop still had the tile buried inside the Size
           fieldset. Same holder, same contents, built here for desktop.
           The order value is set in assets/int-pdp-desktop.css. */
        mountFit();
      }
    } catch (e) {}
  }

  function mountFit() {
    if (q('.int-mob-fit')) return;
    var inner = q('.product__inner');
    var after = q('.int-delivery-estimate') || q('.int-pay') || q('.int-product-reviews');
    if (!inner || !after || !after.parentNode) return;

    var home = document.createElement('div');
    home.className = 'int-mob-fit';
    after.parentNode.insertBefore(home, after.nextSibling);

    /* The tile is injected by the fit app, so it may not exist yet. Same
       polling shape as the mobile file, same 100-try ceiling. */
    var tries = 0;
    var timer = setInterval(function () {
      var tile = document.getElementById('fake-fit-quiz');
      var note = document.getElementById('fake-fit-quiz-note');
      if (tile && home.parentNode) {
        home.appendChild(tile);
        if (note) home.appendChild(note);
        clearInterval(timer);
        return;
      }
      if (++tries > 100) clearInterval(timer);
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();

/* ============================================================
   FIND MY SIZE — the link beside the price.       INTENTION — 2026-09-24
   Moved here from block 6 of assets/int-pdp-mobile.js, which returns above
   820px, so on desktop the link did nothing. This file runs at every width.
   Reuses the Fit Quiz tile's own trigger. Find My Size (assets/int-fms.js)
   also listens for [data-int-mob-quiz] directly. EasySize fallback removed 2026-10-05.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intFindSize) return;
  window.__intFindSize = true;
  function bind() {
    var btn = document.querySelector('[data-int-mob-quiz]');
    if (!btn) return;
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      var tile = document.getElementById('fake-fit-quiz');
      if (tile) tile.click();
    }, false);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
